<div class="section-page">
    <div *ngIf="showAgreementList">
        <div class="section-header-bar" [class.section-header-bar--scrolled]="isScrolled">
            <div class="section-header">
                <div class="section-header__title">
                    <mat-icon class="section-header__icon">view_headline</mat-icon>
                    <div>
                        <div class="section-header__heading">List Agreements</div>
                        <div class="section-header__subtitle">View and manage agreements created for this application</div>
                    </div>
                </div>
                <div class="section-header__actions">
                    <button mat-flat-button color="primary" (click)="createAgreement.emit()">
                        <mat-icon>note_add</mat-icon>
                        Create Agreement
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="isLoading" class="generating-preview">
            <mat-spinner diameter="30" color="primary"></mat-spinner>
            <p class="loading-text">Loading agreements...</p>
        </div>
        <div *ngIf="!isLoading && !envelopeData?.length" class="empty-state">
            <mat-icon class="empty-state__icon">inbox</mat-icon>
            <p class="empty-state__text">No agreements</p>
        </div>
        <table *ngIf="!isLoading && envelopeData?.length" style="overflow: auto;" mat-table [dataSource]="envelopeData" class="flat-table mat-elevation-z0">
            <ng-container matColumnDef="applicantName">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element" 
                    style="text-align: justify; cursor: pointer; color: rgb(21, 118, 209);"
                    (click)="openPreviewWindow(element);">
                    <span>{{ element?.name | uppercase }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="applicantType">
                <th mat-header-cell *matHeaderCellDef> Type </th>
                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                    <span>{{ element?.applicant_type | uppercase }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="clientEmail">
                <th mat-header-cell *matHeaderCellDef> Email </th>
                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                    <span>{{ element?.client_email }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="templateName">
                <th mat-header-cell *matHeaderCellDef> Template </th>
                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                    <span>{{ element?.templateRowId?.template_name?.replaceAll('_', ' ') | uppercase }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element" style="text-align: justify;" >
                    <span [ngClass]="element?.statusId?.status_name === 'completed' ? 'completed' : redStatus.includes(element?.statusId?.status_name) ? 'failed' : 'black'">{{ element?.statusId?.status_name === 'created' ? 'DRAFT' : element?.statusId?.status_name === 'autoresponded' ? 'DELIVERY FAILED' : element?.statusId?.status_name | uppercase }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="createdBy">
                <th mat-header-cell *matHeaderCellDef> Created By </th>
                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                    <span>{{ element?.createdBy?.full_name | uppercase }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef> Created At </th>
                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                    <span>{{ element?.created_at | date: 'yyyy/MM/dd, h:mm:ss a' : 'UTC' }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="sentBy">
                <th mat-header-cell *matHeaderCellDef> Sent By </th>
                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                    <span>{{ element?.sentBy?.full_name | uppercase }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="sentAt">
                <th mat-header-cell *matHeaderCellDef> Sent At </th>
                <td mat-cell *matCellDef="let element" style="text-align: justify;">
                    <span>{{ element?.sent_at | date: 'yyyy/MM/dd, h:mm:ss a' : 'UTC' }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let row; let i = index">
                <button mat-icon-button [matMenuTriggerFor]="actionMenu" [matMenuTriggerData]="{element: row, idx: i}">
                    <mat-icon>more_vert</mat-icon>
                </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="tableHeaders;"></tr>
            <tr mat-row *matRowDef="let row; columns: tableHeaders; let i = index" (click)="onRowClick(row);" [class.active-row]="selectedActionIndex === i">
            </tr>
        </table>
        <mat-menu #actionMenu="matMenu">
            <ng-template let-element="element" matMenuContent>
                <button mat-menu-item (click)="sendEnvelopeAction(element)" 
                [disabled]="element?.statusId?.status_name?.toLowerCase() !== 'created'" 
                *ngIf="allowSend?.includes(element?.statusId?.status_name?.toLowerCase())">
                    Send
                </button>
                <button mat-menu-item (click)="openVoidAction(element)" 
                [disabled]="!allowVoid.includes(element?.statusId?.status_name?.toLowerCase())" 
                *ngIf="allowVoid.includes(element?.statusId?.status_name?.toLowerCase())">
                    Void
                </button>
                <!-- <button mat-menu-item (click)="reSendEnvelopeAction(element)"
                *ngIf="allowResend.includes(element?.statusId?.status_name?.toLowerCase())">
                    Resend
                </button>
                -->
                <button mat-menu-item (click)="deleteEnvelopeAction(element)" [disabled]="element?.statusId?.status_name?.toLowerCase() !== 'created'">Delete</button>
                <button mat-menu-item (click)="uploadToWorkdrive(element)" [disabled]="!allowManualUpload?.includes(element?.statusId?.status_name?.toLowerCase())">Manual Upload</button>
            </ng-template>
        </mat-menu>
    </div>
    <div *ngIf="!showAgreementList">
        <app-agreement-preview-modal 
        *ngIf="selectedEnvelopeData"  
        (applicationChange)="onApplicationChanged($event)"
        [selectedRowData]="selectedEnvelopeData"
        (onCloseEnvelope)="receiveClosedMessage($event)"
        ></app-agreement-preview-modal>
    </div>
</div>
